// Lib
import { isEmpty } from 'lodash/fp';

// Utils
import { prop } from '../immutableHelper';

const orderByOffset = (rangeA, rangeB) => {
    const offsetA = prop('offset', rangeA);
    const offsetB = prop('offset', rangeB);

    return offsetA - offsetB;
};

export default ({ text, ranges }) => {
    if (!ranges || isEmpty(ranges)) {
        return [{ text, isMatch: false }];
    }

    const result = ranges.sort(orderByOffset).reduce(
        (acc, mentionRange, index) => {
            const { textParts, lastOffsetEnd } = acc;

            const offset = prop('offset', mentionRange);
            const length = prop('length', mentionRange);

            // If there's non-mentioned text before this mention
            if (offset !== lastOffsetEnd) {
                const prevText = text.slice(lastOffsetEnd, offset);
                textParts.push({ text: prevText, isMatch: false });
            }

            const endOffset = offset + length;
            const mentionedText = text.slice(offset, endOffset);

            textParts.push({ text: mentionedText, isMatch: true });

            // We're at the final mention range and we need to append the last non-mentioned part of the string
            if (index === ranges.length - 1 && endOffset < text.length - 1) {
                const endText = text.slice(endOffset);
                textParts.push({ text: endText, isMatch: false });
            }

            return {
                textParts,
                lastOffsetEnd: endOffset,
            };
        },
        { textParts: [], lastOffsetEnd: 0 },
    );

    return result.textParts;
};
